// Generated on 2026-10-02T21:21:46.084Z
// This file contains preloaded vehicles brands data from the API
// Do not edit manually - use 'npm run generate:vehicles-brands-data' to regenerate

export const preloadedVehiclesBrands: any = [
  {
    "marca": "TOYOTA",
    "busquedas": "340471"
  },
  {
    "marca": "HONDA",
    "busquedas": "327216"
  },
  {
    "marca": "FORD",
    "busquedas": "266181"
  },
  {
    "marca": "HYUNDAI",
    "busquedas": "161208"
  },
  {
    "marca": "NISSAN",
    "busquedas": "147729"
  },
  {
    "marca": "KIA",
    "busquedas": "79389"
  },
  {
    "marca": "MITSUBISHI",
    "busquedas": "74945"
  },
  {
    "marca": "MAZDA",
    "busquedas": "46799"
  },
  {
    "marca": "CHEVROLET",
    "busquedas": "46276"
  },
  {
    "marca": "JEEP",
    "busquedas": "43068"
  },
  {
    "marca": "ISUZU",
    "busquedas": "27115"
  },
  {
    "marca": "PONTIAC",
    "busquedas": "15202"
  },
  {
    "marca": "BMW",
    "busquedas": "11307"
  },
  {
    "marca": "DODGE",
    "busquedas": "8871"
  },
  {
    "marca": "VOLKSWAGEN",
    "busquedas": "7974"
  },
  {
    "marca": "SUZUKI",
    "busquedas": "7738"
  },
  {
    "marca": "ACURA",
    "busquedas": "2898"
  },
  {
    "marca": "SCION",
    "busquedas": "2640"
  },
  {
    "marca": "SUBARU",
    "busquedas": "2285"
  },
  {
    "marca": "MINI",
    "busquedas": "2227"
  },
  {
    "marca": "GMC",
    "busquedas": "2220"
  },
  {
    "marca": "RAM",
    "busquedas": "2123"
  },
  {
    "marca": "LEXUS",
    "busquedas": "1602"
  },
  {
    "marca": "MERCURY",
    "busquedas": "1222"
  },
  {
    "marca": "MERCEDES-BENZ",
    "busquedas": "1126"
  },
  {
    "marca": "VOLVO",
    "busquedas": "962"
  },
  {
    "marca": "AUDI",
    "busquedas": "732"
  },
  {
    "marca": "CHRYSLER",
    "busquedas": "674"
  },
  {
    "marca": "HUMMER",
    "busquedas": "603"
  },
  {
    "marca": "SATURN",
    "busquedas": "521"
  },
  {
    "marca": "INFINITI",
    "busquedas": "486"
  },
  {
    "marca": "GEO",
    "busquedas": "435"
  },
  {
    "marca": "LINCOLN",
    "busquedas": "313"
  },
  {
    "marca": "LAND ROVER",
    "busquedas": "307"
  },
  {
    "marca": "PORSCHE",
    "busquedas": "280"
  },
  {
    "marca": "CADILLAC",
    "busquedas": "273"
  },
  {
    "marca": "DAIHATSU",
    "busquedas": "153"
  },
  {
    "marca": "FIAT",
    "busquedas": "140"
  },
  {
    "marca": "BUICK",
    "busquedas": "96"
  },
  {
    "marca": "PLYMOUTH",
    "busquedas": "92"
  },
  {
    "marca": "JAGUAR",
    "busquedas": "76"
  },
  {
    "marca": "JMC",
    "busquedas": "72"
  },
  {
    "marca": "DAEWOO",
    "busquedas": "54"
  },
  {
    "marca": "RENAULT",
    "busquedas": "47"
  },
  {
    "marca": "MAHINDRA",
    "busquedas": "24"
  },
  {
    "marca": "JAC",
    "busquedas": "20"
  },
  {
    "marca": "CHANGAN",
    "busquedas": "17"
  },
  {
    "marca": "ZNA",
    "busquedas": "16"
  },
  {
    "marca": "FOTON",
    "busquedas": "10"
  },
  {
    "marca": "JIM",
    "busquedas": "7"
  },
  {
    "marca": "MASERATI",
    "busquedas": "6"
  },
  {
    "marca": "CHERY",
    "busquedas": "5"
  },
  {
    "marca": "PEUGEOT",
    "busquedas": "5"
  },
  {
    "marca": "TESLA",
    "busquedas": "4"
  },
  {
    "marca": "SAAB",
    "busquedas": "3"
  },
  {
    "marca": "DATSUN",
    "busquedas": "2"
  },
  {
    "marca": "EAGLE",
    "busquedas": "2"
  },
  {
    "marca": "BUGATTI",
    "busquedas": "1"
  },
  {
    "marca": "ASTON MARTIN",
    "busquedas": "1"
  },
  {
    "marca": "MAXUS",
    "busquedas": "1"
  },
  {
    "marca": "SMART",
    "busquedas": "1"
  },
  {
    "marca": "CODA",
    "busquedas": "1"
  },
  {
    "marca": "SSANGYONG",
    "busquedas": "1"
  },
  {
    "marca": "LAMBORGHINI",
    "busquedas": "1"
  }
];

export default preloadedVehiclesBrands;
